import { Navigate, useParams } from "react-router-dom";
import { getManual, MANUAL_ROLES } from "../../manuals";
import ManualHome from "./ManualHome";
import ManualTopic from "./ManualTopic";
import RequireManual from "./RequireManual";

export default function ManualRoutes({ page }) {
  const { role, slug } = useParams();
  if (!MANUAL_ROLES.includes(role)) return <Navigate to="/manuals" replace />;
  const pack = getManual(role);
  if (!pack) return <Navigate to="/manuals" replace />;

  return (
    <RequireManual role={role}>
      {page === "topic" && slug ? <ManualTopic role={role} pack={pack} /> : <ManualHome role={role} pack={pack} />}
    </RequireManual>
  );
}
